import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

// let Protected = store.getState().auth.Protected ? true : "";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const getSalesReportGraph = async (
  start,
  end,
  invoice_number,
  delivery_date,
  Payment_method,
  status,
  contact,
  location,
  account
) => {
  try {
    const response = await backend.get(
      `api/order/invoices/?is_public=${store.getState().auth.Protected ? true : ""
      }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}`,
      getConfig()
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSalesReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoices/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getRefundReport =
  (
    start,
    end,
    location
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/refund/?start=${start}&end=${end}&invoice__location__id=${location}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getSalesReportP =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoicesP/?is_public=${store.getState().auth.Protected ? true : ""
          }&keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };



export const getCashRegister =
  (
    start,
    end,
    location,
  ) =>
    async () => {
      try {
        const response = await backend.get(
          `api/accounting/cashregister/?start=${start}&end=${end}&location=${location}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };



export const getBusinessReport = async (start = "", end = "") => {
  try {
    const response = await backend.get(
      `api/accounting/businessreport/?start=${start}&end=${end}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    // throw error;
  }
};

export const getBusinessReportByMonth = async (start = "", end = "") => {
  try {
    const response = await backend.get(
      `api/accounting/businessreportbymonth/?start=${start}&end=${end}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    // throw error;
  }
};

export const downloadBusinessReportByMonthCSV = async (start = "", end = "") => {
  try {
    const response = await backend.get(
      `api/accounting/businessreportbymonth/download_csv/?start=${start}&end=${end}`,
      {
        ...getConfig(),
        responseType: 'blob', // Important for file downloads
      }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `business_report_${start}_to_${end}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  } catch (error) {
    console.log("Error downloading CSV:", error);
    message.error("Failed to download CSV");
  }
};

export const getVATReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    contains_item = "true"
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/vat/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&contains_item=${contains_item}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };



export const getRefundableSalesReportP =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100,
    deliverystart = "",
    deliveryend = "",
    refundable = "true"
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoicesP/?keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}&deliverystart=${deliverystart}&deliveryend=${deliveryend}&refundable=${refundable}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getSalesReportByOutLetMonth =
  (location, month, year) => async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoices/?is_public=${store.getState().auth.Protected ? true : ""
        }&month=${month}&year=${year}&location=${location}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getSalesReportByInvoiceCount = (from, to) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/order/report/${from}/${to}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getDeliveryReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    DeliveryType = ""
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/delivery/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&DeliveryType=${DeliveryType}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getServiceReport =
  (start, end, keyward, employe__id = "", pageno = 1, page_size = 10) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/ServicesP/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&keyward=${keyward}&employe__id=${employe__id}&page=${pageno}&page_size=${page_size}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };


export const getStockHistory = (product_code) => async () => {
  try {
    const response = await backend.get(
      `api/order/stockhistory/?product_code=${product_code}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const getStockHistoryAll = (filters = {}) => async () => {
  try {
    const params = new URLSearchParams();
    if (filters.product_code) params.append('product_code', filters.product_code);
    if (filters.brand) params.append('brand', filters.brand);
    if (filters.brand_name) params.append('brand_name', filters.brand_name);
    if (filters.is_balanced !== undefined && filters.is_balanced !== null) {
      params.append('is_balanced', filters.is_balanced);
    }

    const queryString = params.toString();
    const url = queryString
      ? `api/order/stockhistoryall/?${queryString}`
      : `api/order/stockhistoryall/`;

    const response = await backend.get(url, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};

//  Payment Report
export const getInvoicePaymentsReport =
  (
    start,
    end,
    keyward,
    invoice_id,
    location,
    month,
    year,
    account,
    is_public,
    pageno = 1,
    page_size = 100
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoicepayments-report/?invoice__is_public=${is_public !== undefined ? is_public : ""
          }&keyward=${keyward}&start=${start}&end=${end}&invoice__id=${invoice_id}&invoice__location__id=${location}&month=${month}&year=${year}&account=${account}&page=${pageno}&page_size=${page_size}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getProductStockReport = (filters = {}) => async () => {
  try {
    const params = new URLSearchParams();
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.office) params.append('office', filters.office);
    if (filters.category) params.append('category', filters.category);
    if (filters.brand) params.append('brand', filters.brand);
    if (filters.tag) params.append('tag', filters.tag);
    if (filters.keyword) params.append('keyword', filters.keyword);
    if (filters.page) params.append('page', filters.page);
    if (filters.page_size) params.append('page_size', filters.page_size);

    const queryString = params.toString();
    const url = queryString ? `api/product/stock-report/?${queryString}` : `api/product/stock-report/`;

    const response = await backend.get(url, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};
export const getNewBusinessReport = async (start = "", end = "") => {
  try {
    const response = await backend.get(
      `api/accounting/newbusinessreport/?start=${start}&end=${end}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getNewBusinessReportByMonth = async (start = "", end = "") => {
  try {
    const response = await backend.get(
      `api/accounting/newbusinessreportbymonth/?start=${start}&end=${end}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const downloadNewBusinessReportByMonthCSV = async (start = "", end = "") => {
  try {
    const response = await backend.get(
      `api/accounting/newbusinessreportbymonth/download_csv/?start=${start}&end=${end}`,
      {
        ...getConfig(),
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `new_business_report_${start}_to_${end}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  } catch (error) {
    console.log("Error downloading CSV:", error);
    message.error("Failed to download CSV");
  }
};
